<div class="container p-2">

    <!--<div style="height: 300px" class="bg-primary mt-2">-->
<app-upcoming-date-assessment></app-upcoming-date-assessment>
    <div class="d-flex gap-1 mt-2">
        <mat-form-field appearance="outline" >
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input  [rangePicker]="picker">
                <input matStartDate [(ngModel)]="start" placeholder="Start date">
                <input matEndDate [(ngModel)]="end" placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <!--            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>-->
            <!--            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>-->

        </mat-form-field>&nbsp;
       <mat-form-field appearance="outline">
            <mat-label>Select Centre</mat-label>
            <mat-select [formControl]="centreControl"  (selectionChange)="onCentreSelect($event)">
                <mat-option  value="All" >All Centres </mat-option>
                <mat-option *ngFor="let c of (_centres$|async)" [value]="c.centreCode" >{{c.centreName}} </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-3" >
            <mat-label>Submitted By</mat-label>
            <mat-select [(ngModel)]="submittedBy" (selectionChange)="applyfilters()" >
                <mat-option [value]=null> All Counsellors </mat-option>
                <mat-option *ngFor="let e of counsellors$|async" [value]="e.userName">{{e.userName}}</mat-option>
            </mat-select>
        </mat-form-field>

        <button mat-mini-fab (click)="search()" color="accent"><mat-icon>search</mat-icon></button>
      <button mat-mini-fab (click)="clearAll()" color="accent"><mat-icon>clear</mat-icon></button>

    </div>
    <!--</div>-->


    <section class="card p-2">
      <div class="ngxTableHeader">
        <ul class="header-buttons-left ms-0 mb-0">
          <li class="dropdown">
            <h2>Assessment</h2>
          </li>

          <li class="dropdown m-l-20">
            <label for="search-input"><i class="material-icons search-icon">search</i></label>
            <input placeholder="Search" id="search-input" type="text" class="browser-default search-field"
                   (keyup)='applyFilter($event)' aria-label="Search box" #input>
          </li>
        </ul>
        <ul class="header-buttons mr-2">
          <li class="me-2">
            <button  permission="Assessments" [permissionTypes]="[PermissionType.ADD,PermissionType.ALL]" mat-mini-fab color="primary" routerLink="add-assessment">
              <mat-icon class="col-white" >add</mat-icon>
            </button>
          </li>

          <li>
            <button
              mat-mini-fab color="accent"
              (click)="downloadExcel()">
              <mat-icon>download</mat-icon>
            </button>
          </li>

          <!--      <li>-->
          <!--        <div class="export-button m-l-10" matTooltip="XLSX">-->
          <!--          <img src="assets/images/icons/xlsx.png" alt=""/>-->
          <!--        </div>-->
          <!--      </li>-->
        </ul>
      </div>
        <table mat-table [dataSource]="dataSource" class="example-container table" matSort>

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

          <ng-container matColumnDef="sr.no">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr.No</th>
            <td mat-cell *matCellDef="let element; let i=index"> {{i+1}} </td>
          </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="childName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Child Name</th>
                <td mat-cell *matCellDef="let element"> {{element.childName}} </td>
            </ng-container>



          <!-- Name Column -->
            <ng-container matColumnDef="centreName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Centre</th>
                <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
            </ng-container>
            <!-- Weight Column -->
            <ng-container matColumnDef="parentsName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Parents Name</th>
                <td mat-cell *matCellDef="let element"> {{element.parentsName}} </td>
            </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Type</th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
          </ng-container>


            <!-- Symbol Column -->
            <ng-container matColumnDef="conducted_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Conducted By</th>
                <td mat-cell *matCellDef="let element"> {{element.personConductingTest}} </td>
            </ng-container>

          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Type </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
          </ng-container>

            <ng-container matColumnDef="dateOfAssessment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Assessment Date</th>
                <td mat-cell *matCellDef="let element"> {{(element.dateOfAssessment).toDate()| date:'dd/MM/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button  permission="Assessments" [permissionTypes]="[PermissionType.ALL,PermissionType.VIEW]" mat-icon-button color="primary" (click)="viewAssessment(element)" matTooltip="View"><mat-icon>remove_red_eye</mat-icon></button>
<!--                  <button *ngIf="(counselling[0].edit || counselling[0].all) && editAccess(element)" mat-icon-button color="primary" (click)="viewEdit(element)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>-->
                  <button *ngIf="editAccess(element)" mat-icon-button color="primary"  permission="Assessments" [permissionTypes]="[PermissionType.ALL,PermissionType.EDIT]" (click)="viewEdit(element)" matTooltip="Edit"><mat-icon>edit</mat-icon></button>
                  <button *ngIf="deleteAccess(element)" mat-icon-button color="warn" (click)="delete(element)" matTooltip="Delete Assessment"><mat-icon>delete</mat-icon></button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
      <mat-paginator [pageSizeOptions]="[25,50,100,200,250,500,1000]" aria-label="Select page of assessments"> </mat-paginator>


    </section>

</div>
<router-outlet></router-outlet>
